import { Button } from '@cibli/shared';
import { Briefcase } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface JobListEmptyStateProps {
  hasActiveFilters?: boolean;
  onEditCv?: () => void;
}

export default function JobListEmptyState({
  hasActiveFilters = false,
  onEditCv,
}: JobListEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Briefcase className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">
        {hasActiveFilters
          ? t('dashboard.jobs.empty.titleFiltered')
          : t('dashboard.jobs.empty.title')}
      </h3>
      <p className="text-muted-foreground">
        {hasActiveFilters
          ? t('dashboard.jobs.empty.descriptionFiltered')
          : t('dashboard.jobs.empty.description')}
      </p>
      {onEditCv && (
        <Button className="mt-4" onClick={onEditCv}>
          {t('dashboard.jobs.empty.editCvButton')}
        </Button>
      )}
    </div>
  );
}
